module.exports = __webpack_public_path__ + "img/matt_d.81e3b49f.png";